export default "__VITE_ASSET__BB1FVy3c__"